import { MarketingContainer } from "./ui/MarketingContainer";

const faqs = [
  {
    question:
      "Is MinistryIQ replacing our current church management system?",
    answer:
      "Not necessarily. During the pilot, MinistryIQ can complement your existing tools while providing deeper engagement insights, care workflows, and actionable reporting.",
  },
  {
    question:
      "Can we import our existing member data?",
    answer:
      "Yes. MinistryIQ supports CSV-based member imports with field mapping, validation, duplicate detection, and review before data is committed.",
  },
  {
    question:
      "Can we import data from Breeze?",
    answer:
      "Yes. Breeze data can be exported and imported through MinistryIQ's CSV migration workflow. Additional direct migration tooling may be added based on pilot needs.",
  },
  {
    question:
      "Is our church data secure?",
    answer:
      "Each church's data is isolated, transmitted over encrypted connections, and stored in managed cloud infrastructure with environment and access controls.",
  },
  {
    question:
      "Do you provide onboarding support?",
    answer:
      "Yes. Every selected pilot church receives guided onboarding, help preparing its data, and direct support during initial setup.",
  },
  {
    question:
      "Is MinistryIQ only for large churches?",
    answer:
      "No. MinistryIQ is designed to help churches of different sizes understand attendance, engagement, visitors, and pastoral-care opportunities.",
  },
];

export function FAQSection() {
  return (
    <section
      id="faq"
      className="border-y border-white/5 bg-slate-900/30 py-24"
    >
      <MarketingContainer>
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-300">
            Frequently Asked Questions
          </p>

          <h2 className="mt-4 text-4xl font-black tracking-tight text-white sm:text-5xl">
            Questions from ministry leaders.
          </h2>

          <p className="mt-6 text-lg leading-8 text-slate-400">
            Learn how MinistryIQ fits alongside your current
            church processes and supports your team.
          </p>
        </div>

        <div className="mx-auto mt-14 max-w-4xl divide-y divide-white/10 overflow-hidden rounded-3xl border border-white/10 bg-slate-950/60">
          {faqs.map((faq) => (
            <details
              key={faq.question}
              className="group p-6 open:bg-white/[0.03] sm:p-8"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left text-lg font-semibold text-white">
                {faq.question}

                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-white/10 text-xl text-indigo-300 transition group-open:rotate-45">
                  +
                </span>
              </summary>

              <p className="mt-5 max-w-3xl leading-7 text-slate-400">
                {faq.answer}
              </p>
            </details>
          ))}
        </div>
      </MarketingContainer>
    </section>
  );
}
